import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { linkListStyles } from "@insite/content-library/Widgets/Basic/LinkList";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

linkListStyles.linkListWrapper = mergeToNew(linkListStyles.linkListWrapper, {
    css: css`
        a[class^="StyledButton"] span[class^="TypographyStyle"] {
            color: ${getColor("secondary.main")};
            font-weight: 500;
            margin-bottom: 7px;
            :hover {
                color: ${getColor("primary.main")};
            }
        }
    `,
});
linkListStyles.title = mergeToNew(linkListStyles.title, {
    css: css`
        color: ${getColor("primary.main")};
        font-weight: 400;
        text-transform: uppercase;
    `,
});
